var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11658(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#4E4F54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3327 61.55H36.4893C28.626 61.55 26.666 59.59 26.666 51.7267V37.7267C26.666 29.8633 28.626 27.9033 36.4893 27.9033H61.0593C68.9227 27.9033 70.8827 29.8633 70.8827 37.7267",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.334 72.0965V61.5498",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 52.2166H45.3327",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7275 72.0967H45.3342",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3345 51.8669V65.1902C73.3345 70.7202 71.9578 72.0969 66.4278 72.0969H58.1445C52.6145 72.0969 51.2378 70.7202 51.2378 65.1902V51.8669C51.2378 46.3369 52.6145 44.9602 58.1445 44.9602H66.4278C71.9578 44.9602 73.3345 46.3369 73.3345 51.8669Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2378 64.5832H62.2588",
    stroke: "white",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11658);
export default __webpack_public_path__ + "static/media/Group 11658.64868696988e3cf28324ab7a7414ee61.svg";
export { ForwardRef as ReactComponent };